(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-cookie-consent]');
    if (!root || !window.Shopify || !window.Shopify.loadFeatures) return;

    var mainView = root.querySelector('[data-cookie-consent-main]');
    var panel = root.querySelector('[data-cookie-consent-panel]');
    var toggles = root.querySelectorAll('[data-cookie-consent-toggle]');

    // Read by whatsapp-button.liquid's own fixed positioning, so that
    // floating button sits above this banner instead of underneath it
    // while both are visible at once — this is the only link between
    // the two files.
    function setBannerHeightVar() {
      document.documentElement.style.setProperty('--cookie-banner-height', root.offsetHeight + 'px');
    }

    function show() {
      root.hidden = false;
      setBannerHeightVar();
      requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
    }

    function hide() {
      root.classList.remove('is-visible');
      document.documentElement.style.setProperty('--cookie-banner-height', '0px');
      setTimeout(function () {
        root.hidden = true;
      }, 400);
    }

    function setConsent(consent) {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
        hide();
      });
    }

    root.querySelector('[data-cookie-consent-accept]').addEventListener('click', function () {
      setConsent({ marketing: true, analytics: true, preferences: true, sale_of_data: true });
    });

    root.querySelector('[data-cookie-consent-decline]').addEventListener('click', function () {
      setConsent({ marketing: false, analytics: false, preferences: false, sale_of_data: false });
    });

    root.querySelector('[data-cookie-consent-manage]').addEventListener('click', function () {
      var current = window.Shopify.customerPrivacy.currentVisitorConsent();
      toggles.forEach(function (toggle) {
        var key = toggle.getAttribute('data-cookie-consent-toggle');
        toggle.checked = current[key] === 'yes';
      });
      mainView.hidden = true;
      panel.hidden = false;
      setBannerHeightVar();
    });

    root.querySelector('[data-cookie-consent-back]').addEventListener('click', function () {
      panel.hidden = true;
      mainView.hidden = false;
      setBannerHeightVar();
    });

    root.querySelector('[data-cookie-consent-save]').addEventListener('click', function () {
      var consent = { sale_of_data: false };
      toggles.forEach(function (toggle) {
        var key = toggle.getAttribute('data-cookie-consent-toggle');
        consent[key] = toggle.checked;
      });
      consent.sale_of_data = consent.marketing;
      setConsent(consent);
    });

    // Lets a "Cookie settings" link anywhere on the site (footer, etc.)
    // reopen this same panel later, pre-filled with the visitor's
    // current choices — not just a first-visit banner.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cookie-consent-reopen]');
      if (!trigger) return;
      event.preventDefault();
      var current = window.Shopify.customerPrivacy.currentVisitorConsent();
      toggles.forEach(function (toggle) {
        var key = toggle.getAttribute('data-cookie-consent-toggle');
        toggle.checked = current[key] === 'yes';
      });
      mainView.hidden = true;
      panel.hidden = false;
      show();
    });

    // shouldShowBanner() answers "does this visitor's region require
    // asking at all" — confirmed by direct testing that it keeps
    // returning true even after setTrackingConsent has successfully
    // recorded a real decision (currentVisitorConsent() shows "yes"
    // across the board). Relying on it alone was why the banner kept
    // reappearing after Accept/Decline: it needs pairing with an
    // explicit "has this visitor already decided" check of our own.
    function visitorAlreadyDecided() {
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      return consent.marketing !== '' || consent.analytics !== '' || consent.preferences !== '';
    }

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      if (!visitorAlreadyDecided() && window.Shopify.customerPrivacy.shouldShowBanner()) show();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Delegated (not per-card) since a collection grid can render dozens
  // of cards, and product-recommendations fetches more cards in later.
  document.addEventListener('click', function (event) {
    var prevButton = event.target.closest('[data-card-media-prev]');
    var nextButton = event.target.closest('[data-card-media-next]');
    var button = prevButton || nextButton;
    if (!button) return;
    var media = button.closest('[data-card-media]');
    var track = media ? media.querySelector('[data-card-media-track]') : null;
    if (!track) return;
    track.scrollBy({ left: (prevButton ? -1 : 1) * track.clientWidth, behavior: 'smooth' });
  });

  document.querySelectorAll('[data-card-media-track]').forEach(function (track) {
    var media = track.closest('[data-card-media]');
    var prevButton = media.querySelector('[data-card-media-prev]');
    var nextButton = media.querySelector('[data-card-media-next]');
    var dots = media.querySelectorAll('[data-card-media-dots] .product-card__media-dot');
    if (!prevButton && !nextButton && !dots.length) return;

    var rafPending = false;
    function updateMediaState() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevButton) prevButton.disabled = track.scrollLeft <= 1;
      if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 1;
      if (dots.length) {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }
    }

    updateMediaState();
    track.addEventListener(
      'scroll',
      function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          updateMediaState();
        });
      },
      { passive: true }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-whatsapp-button]');
    if (!root) return;

    var teaser = root.querySelector('[data-whatsapp-teaser]');
    var closeButton = root.querySelector('[data-whatsapp-teaser-close]');
    var closeTimer;
    var openTimer;

    function scheduleTeaser() {
      openTimer = setTimeout(function () {
        teaser.hidden = false;
        requestAnimationFrame(function () {
          teaser.classList.add('is-visible');
        });
        closeTimer = setTimeout(closeTeaser, 10000);
      }, 1800);
    }

    // Don't pop the teaser bubble open while the cookie consent banner
    // is still showing — on languages where its text runs long (e.g.
    // Bulgarian), the two fixed-position overlays end up stacked high
    // enough to cover page content. Wait for the banner to close first.
    var cookieBanner = document.querySelector('[data-cookie-consent]');
    if (cookieBanner && !cookieBanner.hidden) {
      var bannerObserver = new MutationObserver(function () {
        if (cookieBanner.hidden) {
          bannerObserver.disconnect();
          scheduleTeaser();
        }
      });
      bannerObserver.observe(cookieBanner, { attributes: true, attributeFilter: ['hidden'] });
    } else {
      scheduleTeaser();
    }

    function closeTeaser() {
      teaser.classList.remove('is-visible');
      setTimeout(function () {
        teaser.hidden = true;
      }, 300);
    }

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTeaser();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
